import { Stack, TextField } from '@mui/material';
import { isValidLandingPageUrl } from '@provision/landing-page-utils';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { BackgroundImagePreview } from 'src/pages/Settings/memberships/components/background-image-preview';
import { type LandingPageFormValues } from 'src/pages/Settings/memberships/components/landing-page-tab/types';

interface ImageUrlFieldProps {
  name: `blocks.${number}.${'heroImageUrl' | 'contentImageUrl'}`;
  label: string;
  helperText?: string;
  readOnly: boolean;
}

export const ImageUrlField = ({ name, label, helperText, readOnly }: ImageUrlFieldProps) => {
  const { control } = useFormContext<LandingPageFormValues>();
  const value = useWatch({ control, name });

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        validate: (fieldValue) =>
          !String(fieldValue ?? '').trim() ||
          isValidLandingPageUrl(String(fieldValue).trim()) ||
          'Enter a valid URL (https://…)',
      }}
      render={({ field, fieldState }) => (
        <Stack spacing={1.5}>
          <TextField
            {...field}
            value={field.value ?? ''}
            label={label}
            size="small"
            fullWidth
            disabled={readOnly}
            placeholder="https://example.com/image.jpg"
            error={Boolean(fieldState.error)}
            helperText={fieldState.error?.message ?? helperText}
          />
          <BackgroundImagePreview url={typeof value === 'string' ? value : ''} />
        </Stack>
      )}
    />
  );
};
